import { API_BASE_URL } from '../client';

export const SCHEDULE_ENDPOINTS = {
  SCHEDULES: {
    LIST: `${API_BASE_URL}/Schedule`,
    DETAIL: (id: number) => `${API_BASE_URL}/Schedule/${id}`,
    DETAIL_FULL: (id: number) => `${API_BASE_URL}/Schedule/${id}/detail`,
    CREATE: `${API_BASE_URL}/Schedule`,
    UPDATE: (id: number) => `${API_BASE_URL}/Schedule/${id}`,
    DELETE: (id: number) => `${API_BASE_URL}/Schedule/${id}`,
    PUBLISH: (id: number) => `${API_BASE_URL}/Schedule/${id}/publish`,
    REFRESH_MILESTONE_STATUS: `${API_BASE_URL}/Schedule/refresh-milestone-status`,
  },
  SPECS: {
    CREATE: (scheduleId: number) => `${API_BASE_URL}/ScheduleSpec/${scheduleId}/specs`,
    UPDATE: (scheduleId: number, specId: number) => `${API_BASE_URL}/ScheduleSpec/${scheduleId}/specs/${specId}`,
    REPLACE_SKUS: (scheduleId: number, specId: number) =>
      `${API_BASE_URL}/ScheduleSpec/${scheduleId}/specs/${specId}/skus`,
    DELETE: (scheduleId: number, specId: number) => `${API_BASE_URL}/ScheduleSpec/${scheduleId}/specs/${specId}`,
    PAUSE: (scheduleId: number, specId: number) =>
      `${API_BASE_URL}/ScheduleSpec/${scheduleId}/specs/${specId}/pause`,
    TERMINATE: (scheduleId: number, specId: number) =>
      `${API_BASE_URL}/ScheduleSpec/${scheduleId}/specs/${specId}/terminate`,
  },
  MILESTONES: {
    UPDATE: (scheduleId: number, specId: number, milestoneId: number) =>
      `${API_BASE_URL}/ScheduleMilestone/${scheduleId}/specs/${specId}/milestones/${milestoneId}`,
    BATCH: (scheduleId: number) => `${API_BASE_URL}/ScheduleMilestone/${scheduleId}/milestones/batch`,
  },
  NOTES: {
    UPDATE: (scheduleId: number, specId: number, milestoneId: number) =>
      `${API_BASE_URL}/ScheduleMilestone/${scheduleId}/specs/${specId}/notes/${milestoneId}`,
  },
  RELATIONS: {
    GET: (scheduleId: number) => `${API_BASE_URL}/ScheduleRelation/${scheduleId}/relations`,
    SAVE: (scheduleId: number) => `${API_BASE_URL}/ScheduleRelation/${scheduleId}/relations`,
  },
  COLUMN_WIDTHS: {
    SAVE: (scheduleId: number) => `${API_BASE_URL}/ScheduleRelation/${scheduleId}/column-widths`,
  },
} as const;
